import m from 'mithril'
import { css } from '@emotion/css'
import { colors, font, space, card, btnPrimary, input, label } from '../styles/theme.js'
import { authModel } from '../models/auth.js'

const container = css`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 70vh;
`

const formCard = css`
  ${card};
  width: 100%;
  max-width: 400px;
`

const title = css`
  font-size: ${font.size['2xl']};
  font-weight: ${font.weight.bold};
  margin-bottom: ${space.lg};
  text-align: center;
  color: ${colors.brand};
`

const fieldGroup = css`
  margin-bottom: ${space.md};
`

const errorMsg = css`
  color: ${colors.critical};
  font-size: ${font.size.sm};
  margin-bottom: ${space.md};
  text-align: center;
`

export function ResetPasswordView() {
  let newPassword = ''
  let confirmPassword = ''
  let token = ''
  let localError = null

  return {
    oninit() {
      const params = new URLSearchParams(window.location.search)
      token = params.get('token') || ''
      if (!token) {
        localError = 'Missing reset token. Please use the link from your email.'
      }
    },

    view() {
      return m('div', { class: container }, [
        m('form', {
          class: formCard,
          onsubmit(e) {
            e.preventDefault()
            localError = null
            authModel.clearError()

            if (newPassword.length < 8) {
              localError = 'Password must be at least 8 characters.'
              return
            }
            if (newPassword !== confirmPassword) {
              localError = 'Passwords do not match.'
              return
            }

            authModel.resetPassword(token, newPassword)
          },
        }, [
          m('h1', { class: title }, 'Set new password'),

          (authModel.error || localError)
            ? m('div', { class: errorMsg }, authModel.error || localError)
            : null,

          m('div', { class: fieldGroup }, [
            m('label', { class: label }, 'New password'),
            m('input', {
              class: input,
              type: 'password',
              value: newPassword,
              oninput: (e) => { newPassword = e.target.value },
              required: true,
              minlength: 8,
            }),
          ]),

          m('div', { class: fieldGroup }, [
            m('label', { class: label }, 'Confirm password'),
            m('input', {
              class: input,
              type: 'password',
              value: confirmPassword,
              oninput: (e) => { confirmPassword = e.target.value },
              required: true,
              minlength: 8,
            }),
          ]),

          m('button', {
            class: `${btnPrimary} ${css`width: 100%; justify-content: center;`}`,
            type: 'submit',
            disabled: !token,
          }, 'Reset password'),
        ]),
      ])
    },
  }
}
